import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-colorfastness',
  templateUrl: './colorfastness.component.html',
  styleUrls: ['./colorfastness.component.css']
})
export class ColorfastnessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
